export default [
    {
        path: 'relatorio-viagem-motorista',
        component: () => import(
            /* webpackChunkName: 'transporte-paciente-relatorio-viagem-motorista' */
            '@/views/transporte-paciente/relatorio-viagem-motorista/Index'
        ),
        redirect: 'relatorio-viagem-motorista/index',
        children: [
            {
                name: 'transporte-paciente-relatorio-viagem-motorista-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'transporte-paciente-relatorio-viagem-motorista' */
                    '@/views/transporte-paciente/relatorio-viagem-motorista/List.vue'
                ),
            },
        ],
    },
]
